// Converts a KWD amount to the target currency based on the exchange rate.
export const convertKWDToTarget = (kwdAmount, rate) => {
  const amount = Number(kwdAmount);
  if (isNaN(amount)) return 0;
  
  return amount * rate;
};

// Formats a number as a currency string using Intl.NumberFormat.
export const formatCurrency = (amount, code = "KWD", locale = "en-KW", hideSign = false) => {
  try {
    // Resolve the currency's native fraction digits per ISO 4217
    const nativeDigits = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: code,
    })
      .resolvedOptions()
      .maximumFractionDigits;

    const fractionDigits = Math.min(nativeDigits, 3);
    
    const options = {
      style: hideSign ? "decimal" : "currency",
      minimumFractionDigits: Math.max(fractionDigits - 1, 2), // KWD → min 2, show 3rd only if non-zero
      maximumFractionDigits: fractionDigits,
      numberingSystem: "latn",
    };

    if (!hideSign) {
      options.currency = code;
    }

    return new Intl.NumberFormat(locale, options).format(amount);
  } catch (e) {
    const formatted = Number(amount || 0).toFixed(3);
    return hideSign ? formatted : `${formatted} ${code}`;
  }
};
